import { React, useState, useEffect, useContext } from "react";
import CartTable from "./CartTable";
import CartHeader from "./CartHeader";
import CartSummary from "./CartSummary";
import useStyles from "./CartStyles";
import { StaffCommissionDetailContext } from "../Context/StaffCommissionDetailsContext";
import { useCart } from "../Context/CartContext";
import { useSnackbar } from "react-simple-snackbar";
import { usePayNow } from "../Context/PayNowContext";
import { useDiscount } from "../Context/DiscountContext";
import { useTheme } from "@material-ui/core/styles";
import { Button, Drawer, Divider } from "@material-ui/core";
import usePermissions from "../utils/permissions";

function Cart({ open, handleDrawerClose, currency, invoice, invoices }) {
  const classes = useStyles();
  const {
    staffCommissionDetail,
    setStaffCommissionDetail,
    staffCommissionDetailsArray,
    setStaffCommissionDetailsArray,
  } = useContext(StaffCommissionDetailContext);
  const theme = useTheme();
  const { cartItems, setCartItems, setVat, handleCloseQtyDialog } = useCart();
  const { openPayNow, handlePayNow } = usePayNow();
  const { setDiscountVal, setDiscountFlag } = useDiscount();
  // console.log(cartItems);

  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    isAdmin,
  } = usePermissions();
  // const [openSnackbar, closeSnackbar] = useSnackbar(options);

  useEffect(() => {
    if (invoice) {
      // Map over invoice.items and spread each item's properties while adding quantity
      const mappedItems = invoice.items.map(({ item, quantity }) => ({
        ...item,
        quantity,
      }));
      setCartItems(mappedItems);
      // console.log("Useeffect run ");
      // Keep the rest of the logic unchanged
      invoice?.discount ? setDiscountFlag(true) : setDiscountFlag(false);
      setDiscountVal(invoice.discount);
      setVat(invoice.vat);
    }
  }, [invoice]);

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <CartHeader
        classes={classes}
        theme={theme}
        handleDrawerClose={handleDrawerClose}
        invoices={invoices}
      />

      <Divider />

      <CartTable currency={currency} />

      <Divider />
      <CartSummary currency={currency} />
      <Divider />
      {/* <Button onClick={() => console.log(staffCommissionDetailsArray)}>Show</Button> */}

      <Button
        variant="contained"
        color="primary"
         onClick={() => {
          handleCloseQtyDialog(); 
          handlePayNow();         
        }}
        className={classes.payNowButton}
        disabled={
          cartItems.length === 0 ||
          openPayNow ||
          permissionsLoading ||
          (!isAdmin() && !canCreatePage("Invoice"))
        }
        style={{
          cursor:
            permissionsLoading || (!isAdmin() && !canCreatePage("Invoice"))
              ? "not-allowed"
              : "pointer",
        }}
      >
        Save and Continue
      </Button>
    </Drawer>
  );
}
export default Cart;
